import Component from '@glimmer/component'
import type { State } from 'reactiveweb/function'
import { NoDataMessage } from 'district-ui-client/components/no-data-message'
import { ErrorsUnexpected } from 'district-ui-client/components/errors/unexpected'
import FidgetSpinnerWaveComponent from '@blakeelearning/fidget/components/fidget/spinner/wave'

interface Signature {
  Element: HTMLDivElement
  Args: {
    reportStates: State<unknown>[]
  }
}

export class NoReportValue extends Component<Signature> {
  get isLoading() {
    return this.args.reportStates.some((state) => state.isPending)
  }

  get hasFailed() {
    return this.args.reportStates.some((state) => state.isError || state.isRejected)
  }

  <template>
    <div ...attributes>
      {{#if this.isLoading}}
        <FidgetSpinnerWaveComponent @centered={{true}} data-test-report-loading />
      {{else if this.hasFailed}}
        <ErrorsUnexpected data-test-report-error />
      {{else}}
        <NoDataMessage data-test-report-empty />
      {{/if}}
    </div>
  </template>
}

export default NoReportValue
